import { ObservationService } from 'client/services';

const loader = async ({ request }) => {
    const url = new URL(request.url);
    const observations = await ObservationService.getObservations(url.searchParams);
    return { observations };
};

export default loader;
